import React from "react";
import { Link } from "react-router-dom";

export default function Legal({ tipo }) {
  const privacy = tipo === "privacidade";
  return (
    <main className="app-conteudo legal">
      <Link to="/">← DiárioMed</Link>
      <p className="sobretitulo">DiárioMed</p>
      <h1>{privacy ? "Privacidade" : "Termos de uso"}</h1>
      <p><strong>Documento em elaboração.</strong> Antes de disponibilizar o produto para uso real, publique os dados legais da empresa/controlador, canais de contato, bases legais, prazos de retenção, direitos dos titulares, subprocessadores e política de atendimento a incidentes.</p>
      <p>O DiárioMed organiza registros informados pelo paciente para compartilhamento com o profissional responsável. Não oferece diagnóstico, triagem de emergência ou recomendação clínica automatizada.</p>
      {privacy && <p>O Tracking Hub foi removido do site. As ferramentas públicas mantêm os registros somente na memória da página durante a sessão; esses valores não são enviados ao servidor nem persistem após fechar ou atualizar a aba. Este texto ainda precisa ser completado e revisado antes do uso com dados reais.</p>}
      <p>Não insira dados reais de pacientes até a revisão jurídica e de segurança desta política.</p>
    </main>
  );
}
